import {
  SET_PRIZE_POOL_ACTIVITY_LIST,
  SET_PRIZE_POOL_ACTIVITY_LIST_SORT,
  SET_PRIZE_POOL_ACTIVITY_LIST_PAGE_NUM,
  SET_PRIZE_POOL_ACTIVITY_LIST_PAGE_TOTAL,
  SET_PRIZE_POOL_ACTIVITY_LIST_PAGE_SIZE,
  SET_PRIZE_POOL_ACTIVITY_LIST_SEARCHING,
  SET_PRIZE_POOL_ACTIVITY_LIST_LOADING,
  SET_PRIZE_POOL_ACTIVITY_LIST_QUERY,
  SET_PRIZE_LIST,
  SET_PRIZE_LIST_QUERY,
  SET_PRIZE_LIST_PAGE_NUM,
  SET_PRIZE_LIST_PAGE_SIZE,
  SET_PRIZE_LIST_PAGE_TOTAL,
  SET_RECEIVE_DETAIL_LIST,
  SET_RECEIVE_DETAIL_LIST_QUERY,
  SET_RECEIVE_DETAIL_LIST_SEARCHING,
  SET_RECEIVE_DETAIL_LIST_PAGE_TOTAL,
  SET_RECEIVE_DETAIL_LIST_PAGE_NUM,
  SET_RECEIVE_DETAIL_LIST_PAGE_SIZE,
} from './mutation-types'
import api from '@/api'
import _ from 'lodash'

const initQuery = () => ({
  pageNum: 1,
  pageSize: 50,
  name: '',
  admin: '',
  startTime: '',
  endTime: '',
  startTimeOrder: '',
  endTimeOrder: '',
})

const receiveDetailInitQuery = () => ({
  pageNum: 1,
  pageSize: 50,
  prizeType: '',
  userId: '',
  userName: '',
  status: '',
  activityId: '',
})

const prizesInitQuery = () => ({
  activityId: '',
  pageSize: 50,
  pageNum: 1,
})

const state = {
  loading: false,
  searching: false,
  initQuery: initQuery(),
  receiveDetailSearching: false,
  initReceiveDetailQuery: receiveDetailInitQuery(),
  prizePoolActivity: {
    list: [],
    listPageTotal: 0,
    query: initQuery(),
    sort: {},
  },
  prizes: {
    list: [],
    listPageTotal: 0,
    query: prizesInitQuery(),
  },
  receiveDetail: {
    list: [],
    listPageTotal: 0,
    query: receiveDetailInitQuery(),
  },
}

const mutations = {
  [SET_PRIZE_POOL_ACTIVITY_LIST] (state, payload) {
    state.prizePoolActivity.list = payload
  },
  [SET_PRIZE_POOL_ACTIVITY_LIST_SORT] (state, payload) {
    state.prizePoolActivity.sort = payload
  },
  [SET_PRIZE_POOL_ACTIVITY_LIST_PAGE_NUM] (state, payload) {
    state.prizePoolActivity.query.pageNum = payload
  },
  [SET_PRIZE_POOL_ACTIVITY_LIST_PAGE_TOTAL] (state, payload) {
    state.prizePoolActivity.listPageTotal = payload
  },
  [SET_PRIZE_POOL_ACTIVITY_LIST_PAGE_SIZE] (state, payload) {
    state.prizePoolActivity.query.pageSize = payload
  },
  [SET_PRIZE_POOL_ACTIVITY_LIST_SEARCHING] (state, payload) {
    state.searching = payload
  },
  [SET_PRIZE_POOL_ACTIVITY_LIST_LOADING] (state, payload) {
    state.loading = payload
  },
  [SET_PRIZE_POOL_ACTIVITY_LIST_QUERY] (state, payload) {
    state.prizePoolActivity.query = {
      ...state.prizePoolActivity.query,
      ...payload,
    }
  },
  [SET_PRIZE_LIST] (state, payload) {
    state.prizes.list = payload
  },
  [SET_PRIZE_LIST_PAGE_NUM] (state, payload) {
    state.prizes.query.pageNum = payload
  },
  [SET_PRIZE_LIST_PAGE_SIZE] (state, payload) {
    state.prizes.query.pageSize = payload
  },
  [SET_PRIZE_LIST_PAGE_TOTAL] (state, payload) {
    state.prizes.listPageTotal = payload
  },
  [SET_PRIZE_LIST_QUERY] (state, payload) {
    state.prizes.query = {
      ...state.prizes.query,
      ...payload,
    }
  },
  [SET_RECEIVE_DETAIL_LIST] (state, payload) {
    state.receiveDetail.list = payload
  },
  [SET_RECEIVE_DETAIL_LIST_QUERY] (state, payload) {
    state.receiveDetail.query = {
      ...state.receiveDetail.query,
      ...payload,
    }
  },
  [SET_RECEIVE_DETAIL_LIST_SEARCHING] (state, payload) {
    state.receiveDetailSearching = payload
  },
  [SET_RECEIVE_DETAIL_LIST_PAGE_TOTAL] (state, payload) {
    state.receiveDetail.listPageTotal = payload
  },
  [SET_RECEIVE_DETAIL_LIST_PAGE_NUM] (state, payload) {
    state.receiveDetail.query.pageNum = payload
  },
  [SET_RECEIVE_DETAIL_LIST_PAGE_SIZE] (state, payload) {
    state.receiveDetail.query.pageSize = payload
  },
}

const actions = {
  async setPrizePoolActivityList ({commit, state}) {
    try {
      let query = {}
      _.forIn(state.prizePoolActivity.query, (v, k) => {
        if (v !== '') query[k] = v
      })
      let params = {
        ...state.prizePoolActivity.sort,
        ...query,
        pageNum: state.prizePoolActivity.query.pageNum,
        pageSize: state.prizePoolActivity.query.pageSize,
      }
      commit(SET_PRIZE_POOL_ACTIVITY_LIST_LOADING, true)
      const {data: {items, total}} = await api.deployApi.getAwardActivities(params)
      commit(SET_PRIZE_POOL_ACTIVITY_LIST_LOADING, false)
      commit(SET_PRIZE_POOL_ACTIVITY_LIST_SEARCHING, false)
      commit(SET_PRIZE_POOL_ACTIVITY_LIST, items)
      commit(SET_PRIZE_POOL_ACTIVITY_LIST_PAGE_TOTAL, total)
    } catch (error) {
      commit(SET_PRIZE_POOL_ACTIVITY_LIST_LOADING, false)
      commit(SET_PRIZE_POOL_ACTIVITY_LIST_SEARCHING, false)
      commit(SET_PRIZE_POOL_ACTIVITY_LIST, [])
      commit(SET_PRIZE_POOL_ACTIVITY_LIST_PAGE_TOTAL, 0)
    }
  },
  initPrizePoolActivityList ({dispatch}) {
    dispatch('setPrizePoolActivityList')
  },
  async changePrizePoolActivityListPage ({commit, dispatch}, payload) {
    commit(SET_PRIZE_POOL_ACTIVITY_LIST_PAGE_NUM, payload.currentPage)
    if (payload.refresh) dispatch('setPrizePoolActivityList')
  },
  changePrizePoolActivityListPageSize ({commit, dispatch}, payload) {
    commit(SET_PRIZE_POOL_ACTIVITY_LIST_PAGE_SIZE, payload.listPageSize)
    dispatch('changePrizePoolActivityListPage', {currentPage: 1})
  },
  setPrizePoolActivityListQuery ({commit, dispatch}, payload) {
    commit(SET_PRIZE_POOL_ACTIVITY_LIST_QUERY, payload)
  },
  changePrizePoolActivitySort ({commit, dispatch}, payload) {
    commit(SET_PRIZE_POOL_ACTIVITY_LIST_SORT, payload)
    dispatch('changePrizePoolActivityListPage', {currentPage: 1, refresh: true})
  },
  async addAwardActivity ({dispatch}, payload) {
    const {code} = await api.deployApi.addAwardActivity(payload)
    return code
  },
  async editAwardActivity ({dispatch}, payload) {
    const {code} = await api.deployApi.editAwardActivity(payload)
    return code
  },
  async deleteAwardActivity ({dispatch}, payload) {
    const {code} = await api.deployApi.deleteAwardActivity(payload)
    return code
  },
  async getActivityPrizes ({commit}, payload) {
    try {
      let query = {}
      _.forIn(state.prizes.query, (v, k) => {
        if (v !== '') query[k] = v
      })
      const {data: {items, total}} = await api.deployApi.getActivityPrizes(query)
      commit(SET_PRIZE_LIST, items)
      commit(SET_PRIZE_LIST_PAGE_TOTAL, total)
    } catch (error) {
      commit(SET_PRIZE_LIST, [])
      commit(SET_PRIZE_LIST_PAGE_TOTAL, 0)
    }
  },
  initActivityPrizes ({dispatch}, payload) {
    dispatch('getActivityPrizes')
  },
  changePrizesQuery ({commit, dispatch}, payload) {
    commit(SET_PRIZE_LIST_QUERY, payload)
  },
  async changePrizesListPage ({commit, dispatch}, payload) {
    commit(SET_PRIZE_LIST_PAGE_NUM, payload.currentPage)
    if (payload.refresh) dispatch('getActivityPrizes')
  },
  changePrizesListPageSize ({commit, dispatch}, payload) {
    commit(SET_PRIZE_LIST_PAGE_SIZE, payload.listPageSize)
    dispatch('changePrizesListPage', {currentPage: 1})
  },
  async addActivityPrize ({dispatch}, payload) {
    const {code} = await api.deployApi.addActivityPrize(payload)
    return code
  },
  async editActivityPrize ({dispatch}, payload) {
    const {code} = await api.deployApi.editActivityPrize(payload)
    return code
  },
  async deleteActivityPrize ({dispatch}, payload) {
    const {code} = await api.deployApi.deleteActivityPrize(payload)
    return code
  },
  async setReceiveDetailList ({commit, state}) {
    try {
      let query = {}
      _.forIn(state.receiveDetail.query, (v, k) => {
        if (v !== '') query[k] = v
      })
      let params = {
        ...query,
        pageNum: state.receiveDetail.query.pageNum,
        pageSize: state.receiveDetail.query.pageSize,
      }
      const {data: {items, total}} = await api.deployApi.getUserAwardRecord(params)
      commit(SET_RECEIVE_DETAIL_LIST_SEARCHING, false)
      commit(SET_RECEIVE_DETAIL_LIST, items)
      commit(SET_RECEIVE_DETAIL_LIST_PAGE_TOTAL, total)
    } catch (error) {
      commit(SET_RECEIVE_DETAIL_LIST_SEARCHING, false)
      commit(SET_RECEIVE_DETAIL_LIST, [])
      commit(SET_RECEIVE_DETAIL_LIST_PAGE_TOTAL, 0)
    }
  },
  initReceiveDetailList ({dispatch}) {
    dispatch('setReceiveDetailList')
  },
  async changeReceiveDetailListPage ({commit, dispatch}, payload) {
    commit(SET_RECEIVE_DETAIL_LIST_PAGE_NUM, payload.currentPage)
    if (payload.refresh) dispatch('setReceiveDetailList')
  },
  changeReceiveDetailListPageSize ({commit, dispatch}, payload) {
    commit(SET_RECEIVE_DETAIL_LIST_PAGE_SIZE, payload.listPageSize)
    dispatch('changeReceiveDetailListPage', {currentPage: 1})
  },
  setReceiveDetailListQuery ({commit, dispatch}, payload) {
    commit(SET_RECEIVE_DETAIL_LIST_QUERY, payload)
  },
  async exchangePrize ({dispatch}, payload) {
    const {code} = await api.deployApi.exchangePrize(payload)
    return code
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
